import React from 'react';

// --- STYLES ---
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap-icons/font/bootstrap-icons.css';

// --- LOGOS ---
import msmeLogo from '../assets/msme.png';
import isoLogo from '../assets/iso_logo.png';

const skillsUpriseLogo = "https://skillsuprise.com/data/cyberPDF/sklogo.png";

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .contact-page-container {
    background-color: #004a99;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    min-height: 100vh;
    padding-bottom: 2rem;
  }

  /* --- Header Section --- */
  .contact-header {
    background-color: #fff;
    color: #333;
    padding: 1rem 1.5rem;
    margin-bottom: 3rem;
  }
  .header-logo {
      max-height: 40px;
  }
  .header-contact-info {
    font-size: 0.9rem;
    text-align: right;
    font-weight: 500;
  }
  .header-contact-info p {
      margin-bottom: 0.25rem;
  }

  /* --- Main Content Sections --- */
  .contact-content {
      padding: 0 1.5rem;
      max-width: 800px;
      margin: 0 auto;
  }
  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }
  .contact-info p {
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 0.75rem;
  }
  .contact-info strong {
      font-weight: 700;
  }

  /* Buttons */
  .btn-call {
    background-color: #7fffd4;
    color: #004a99;
    border: 1px solid #7fffd4;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    transition: background-color 0.2s ease;
    margin-top: 1rem;
    text-decoration: none;
  }
  .btn-call i {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
  .btn-call:hover {
      background-color: #66e7bd;
      color: #003a7d;
  }
  .btn-whatsapp {
    background-color: #25d366;
    color: #fff;
    border: 1px solid #25d366;
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    transition: background-color 0.2s ease;
    margin-top: 1rem;
    text-decoration: none;
  }
  .btn-whatsapp i {
    margin-right: 0.5rem;
    font-size: 1.3rem;
  }
    .btn-whatsapp:hover {
      background-color: #1ebe59;
  }

  /* Divider */
  .divider {
    border: 0;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 3rem 0;
  }

  /* Demo Section */
  .demo-text {
    font-size: 1.15rem;
    line-height: 1.7;
    margin-bottom: 1.5rem;
  }
  .demo-text strong {
      color: #ffc107;
      font-weight: 700;
  }
  .demo-text q {
      font-style: italic;
      color: #e0e0e0;
  }

  /* --- Footer Section (MODIFIED CSS) --- */
  .contact-footer {
    background-color: #fff;
    color: #333;
    padding: 1.5rem;
    margin-top: 4rem;
  }
  .footer-logo {
      max-height: 50px;
  }
  .footer-address {
    font-size: 0.9rem;
    /* text-align is now controlled by Bootstrap classes */
  }
    .footer-address p {
      margin-bottom: 0.25rem;
    }
    .footer-address strong {
       font-weight: 600;
    }

  /* --- Responsive Adjustments (Simplified) --- */
  @media (max-width: 767.98px) {
    .contact-header {
        padding: 0.75rem 1rem;
        margin-bottom: 2rem;
    }
    .header-contact-info {
        text-align: left;
        margin-top: 0.5rem;
        font-size: 0.8rem;
    }
    .contact-content {
        padding: 0 1rem;
    }
    .section-title {
        font-size: 1.2rem;
        margin-bottom: 1rem;
    }
    .contact-info p {
        font-size: 1rem;
        color: white
    }
    .btn-call, .btn-whatsapp {
        font-size: 0.8rem;
        padding: 0.6rem 1.2rem;
        width: 100%;
        justify-content: center;
    }
    .divider {
        margin: 2rem 0;
    }
    .demo-text {
        font-size: 1rem;
        color: white
    }
    .contact-footer {
        margin-top: 3rem;
        padding: 1rem;
    }
    .footer-address {
       font-size: 0.8rem;
       /* text-align: center; is now handled by Bootstrap classes */
    }
  }
`;

const ContactPage = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="contact-page-container">
        
        {/* --- 1. Header Section --- */}
        <div className="contact-header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                  <img src={skillsUpriseLogo} alt="Skills Uprise Logo" className="header-logo" />
              </div>
              <div className="col-md-6">
                <div className="header-contact-info">
                    <p><strong>Phone :</strong> 9490174876</p>
                    <p><strong>Website :</strong> www.skillsuprise.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- Main Content --- */}
        <div className="contact-content">
          <h1 className="section-title">Contact Us For Registration</h1>
          <div className="contact-info">
            <p><strong>Phone :</strong> 9490174876</p>
            <p><strong>Website :</strong> www.skillsuprise.com</p>
          </div>
          <a href="tel:9490174876" className="btn-call">
            <i className="bi bi-telephone-fill"></i> Click Here to Call
          </a>
          <hr className="divider" />
          <h2 className="section-title">Request A Free Demo</h2>
          <p className="demo-text">
              Send a WhatsApp Message <strong>I Need Demo</strong> to <strong>9490174876</strong> to get a Free Demo
          </p>
          <a href="https://wa.me/919490174876?text=I%20Need%20Demo" target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            <i className="bi bi-whatsapp"></i> Click Here to Send WhatsApp Message
          </a>
        </div>
        
        {/* --- 4. Footer Section (MODIFIED JSX) --- */}
        <div className="contact-footer">
            <div className="container">
              {/* This row handles the responsive layout:
                - On Mobile (default): col-6, col-6, col-12
                  - Row 1: MSME (50%), ISO (50%)
                  - Row 2: Address (100%)
                - On Desktop (md): col-md-4, col-md-4, col-md-4
                  - Row 1: MSME (33%), ISO (33%), Address (33%)
              */}
              <div className="row align-items-center">
                
                {/* Col 1: MSME Logo */}
                <div className="col-6 col-md-4 text-center text-md-start">
                    <img src={msmeLogo} alt="MSME Logo" className="footer-logo" />
                </div>
                
                {/* Col 2: ISO Logo */}
                <div className="col-6 col-md-4 text-center">
                    <img src={isoLogo} alt="ISO Logo" className="footer-logo" style={{ height: '50px' }}/>
                </div>
                
                {/* Col 3: Address (Adds margin-top on mobile only) */}
                <div className="col-12 col-md-4 mt-3 mt-md-0">
                    <div className="footer-address text-center text-md-end">
                      <p><strong>Address :</strong> Beside Medicover Hospitals</p>
                      <p>MVP Colony, Visakhapatnam, 530017</p>
                    </div>
                </div>

              </div>
            </div>
        </div>

      </div>
    </>
  );
};

export default ContactPage;